import IsAuthenticated from "@/permissions/IsAuthenticated";
import HasGroupAccess from "@/permissions/HasGroupAccess";
import {
  GROUP_NAME,
  HOME_ROUTE_NAME,
  TITLE
} from "@/modules/foz_chapeco/settings";

const hasGroupAccess = HasGroupAccess(GROUP_NAME);
const isAuthenticated = IsAuthenticated();

export default [
  {
    path: "/foz-chapeco",
    name: HOME_ROUTE_NAME,
    meta: {
      title: TITLE,
      permissions: [isAuthenticated, hasGroupAccess]
    },
    component: () =>
      import(/* webpackChunkName: "foz_chapeco" */ "./views/FozChapeco.vue"),
    redirect: {
      name: `${HOME_ROUTE_NAME}.alerts`
    },
    children: [
      {
        path: "alerts",
        name: `${HOME_ROUTE_NAME}.alerts`,
        meta: {
          title: "Alertas"
        },
        component: () =>
          import(/* webpackChunkName: "foz_chapeco" */ "./views/Alerts.vue")
      },
      {
        path: "reservoir",
        name: `${HOME_ROUTE_NAME}.reservoir`,
        meta: {
          title: "Nível Reservatório"
        },
        component: () =>
          import(/* webpackChunkName: "foz_chapeco" */ "./views/Reservoir.vue")
      },
      {
        path: "prisms",
        name: `${HOME_ROUTE_NAME}.prisms`,
        meta: {
          title: "Prismas"
        },
        component: () =>
          import(/* webpackChunkName: "foz_chapeco" */ "./views/Prisms.vue")
      },
      {
        path: "sensors",
        name: `${HOME_ROUTE_NAME}.sensors`,
        meta: {
          title: "Sensores"
        },
        component: () =>
          import(/* webpackChunkName: "foz_chapeco" */ "./views/Sensors.vue")
      },
      {
        path: "visualization",
        name: `${HOME_ROUTE_NAME}.visualization`,
        meta: {
          title: "Visualização"
        },
        component: () =>
          import(
            /* webpackChunkName: "foz_chapeco" */ "./views/Visualization.vue"
          )
      }
    ]
  },
  {
    path: "/foz-chapeco/simulator",
    name: `${HOME_ROUTE_NAME}.simulator`,
    meta: {
      title: "Simulador",
      permissions: [isAuthenticated, hasGroupAccess]
    },
    component: () =>
      import(/* webpackChunkName: "foz_chapeco" */ "./views/Simulator.vue"),
    redirect: {
      name: `${HOME_ROUTE_NAME}.simulator.input`
    },
    children: [
      {
        path: "input",
        name: `${HOME_ROUTE_NAME}.simulator.input`,
        meta: {
          title: "Dados de entrada"
        },
        component: () =>
          import(
            /* webpackChunkName: "foz_chapeco" */ "./views/simulator/InputData"
          )
      },
      {
        path: "calculate",
        name: `${HOME_ROUTE_NAME}.simulator.calculate`,
        meta: {
          title: "Calcular"
        },
        component: () =>
          import(
            /* webpackChunkName: "foz_chapeco" */ "./views/simulator/Calculate.vue"
          )
      },
      {
        path: "output",
        name: `${HOME_ROUTE_NAME}.simulator.output`,
        meta: {
          title: "Resultados"
        },
        component: () =>
          import(
            /* webpackChunkName: "foz_chapeco" */ "./views/simulator/OutputData"
          )
      }
    ]
  }
];
